<div class="page-wrapper">
  <!-- Background Elements -->
  <div class="background-elements">
    <div class="gradient-circle gradient-circle-1"></div>
    <div class="gradient-circle gradient-circle-2"></div>
    <div class="gradient-circle gradient-circle-3"></div>
  </div>

  <!-- Main Content -->
  <div class="page-container">
    <!-- Header Section -->
    <header class="page-header">
      <div class="header-wrapper">
        <!-- Navigation -->
        <nav class="breadcrumb" aria-label="breadcrumb">
          <a routerLink="/home" class="breadcrumb-link">
            <i class="fas fa-home"></i>
            <span>Tableau de bord</span>
          </a>
          <i class="fas fa-chevron-right"></i>
          <span class="current">Nouveau Client</span>
        </nav>
        
        <!-- Title Section -->
        <div class="header-title-wrapper">
          <div class="title-content">
            <h1 class="page-title">Créer un nouveau client</h1>
            <p class="page-subtitle">Remplissez le formulaire ci-dessous pour ajouter un nouveau client à votre base de données</p>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Form Section -->
    <div class="content-wrapper">
      <!-- Form Card -->
      <div class="glass-card form-card">
        <form [formGroup]="clientForm" (ngSubmit)="addClient()" class="client-form">
          <!-- Progress Indicator -->
          <div class="form-progress-wrapper">
            <div class="progress-stats">
              <span class="progress-label">Progression du formulaire</span>
              <span class="progress-percentage">{{ getFormProgress() }}%</span>
            </div>
            <div class="progress-bar">
              <div class="progress-fill" [style.width.%]="getFormProgress()"></div>
            </div>
            <div class="progress-info">
              <span>* Champs obligatoires</span>
              <span>{{ getFormProgress() < 100 ? 'Formulaire incomplet' : 'Formulaire complet' }}</span>
            </div>
          </div>

          <!-- Form Content -->
          <div class="form-content">
            <!-- Personal Information -->
            <section class="form-section">
              <div class="section-header">
                <div class="section-icon">
                  <i class="fas fa-user-circle"></i>
                </div>
                <div class="section-title">
                  <h2>Informations Personnelles</h2>
                  <p>Les champs marqués d'un * sont obligatoires</p>
                </div>
              </div>

              <div class="fields-grid">
                <div class="form-field" [class.field-valid]="f['lastName'].valid && f['lastName'].touched"
                     [class.field-invalid]="f['lastName'].invalid && f['lastName'].touched">
                  <label for="lastName">Nom de famille *</label>
                  <div class="input-container">
                    <i class="fas fa-user field-icon"></i>
                    <input 
                      type="text" 
                      id="lastName" 
                      formControlName="lastName"
                      placeholder="Ex: Dupont"
                    />
                    <div class="field-status">
                      <i class="fas fa-check-circle success-icon"></i>
                      <i class="fas fa-exclamation-circle error-icon"></i>
                    </div>
                  </div>
                  <div class="error-message" *ngIf="f['lastName'].touched && f['lastName'].invalid">
                    {{ getErrorMessage('lastName') }}
                  </div>
                </div>

                <div class="form-field" [class.field-valid]="f['firstName'].valid && f['firstName'].touched"
                     [class.field-invalid]="f['firstName'].invalid && f['firstName'].touched">
                  <label for="firstName">Prénom *</label>
                  <div class="input-container">
                    <i class="fas fa-user field-icon"></i>
                    <input 
                      type="text" 
                      id="firstName" 
                      formControlName="firstName"
                      placeholder="Ex: Jean"
                    />
                    <div class="field-status">
                      <i class="fas fa-check-circle success-icon"></i>
                      <i class="fas fa-exclamation-circle error-icon"></i>
                    </div>
                  </div>
                  <div class="error-message" *ngIf="f['firstName'].touched && f['firstName'].invalid">
                    {{ getErrorMessage('firstName') }}
                  </div>
                </div>
              </div>
            </section>

            <!-- Contact Information -->
            <section class="form-section">
              <div class="section-header">
                <div class="section-icon">
                  <i class="fas fa-address-card"></i>
                </div>
                <div class="section-title">
                  <h2>Coordonnées</h2>
                  <p>Informations de contact optionnelles</p>
                </div>
              </div>

              <div class="fields-grid">
                <div class="form-field" [class.field-valid]="f['email'].valid && f['email'].value"
                     [class.field-invalid]="f['email'].invalid && f['email'].touched && f['email'].value">
                  <label for="email">Adresse email <span class="optional-label">(Optionnel)</span></label>
                  <div class="input-container">
                    <i class="fas fa-envelope field-icon"></i>
                    <input 
                      type="email" 
                      id="email" 
                      formControlName="email"
                      placeholder="Ex: jean.dupont@email.com"
                    />
                    <div class="field-status">
                      <i class="fas fa-check-circle success-icon"></i>
                      <i class="fas fa-exclamation-circle error-icon"></i>
                    </div>
                  </div>
                  <div class="error-message" *ngIf="f['email'].touched && f['email'].invalid && f['email'].value">
                    {{ getErrorMessage('email') }}
                  </div>
                </div>

                <div class="form-field" [class.field-valid]="f['phoneNumber'].valid && f['phoneNumber'].value"
                     [class.field-invalid]="f['phoneNumber'].invalid && f['phoneNumber'].touched && f['phoneNumber'].value">
                  <label for="phoneNumber">Numéro de téléphone <span class="optional-label">(Optionnel)</span></label>
                  <div class="input-container">
                    <i class="fas fa-phone field-icon"></i>
                    <input 
                      type="tel" 
                      id="phoneNumber" 
                      formControlName="phoneNumber"
                      placeholder="Ex: 06 12 34 56 78"
                    />
                    <div class="field-status">
                      <i class="fas fa-check-circle success-icon"></i>
                      <i class="fas fa-exclamation-circle error-icon"></i>
                    </div>
                  </div>
                  <div class="error-message" *ngIf="f['phoneNumber'].touched && f['phoneNumber'].invalid && f['phoneNumber'].value">
                    {{ getErrorMessage('phoneNumber') }}
                  </div>
                </div>
              </div>
            </section>
          </div>

          <!-- Form Actions -->
          <div class="form-actions">
            <button type="button" class="btn btn-secondary" routerLink="/home">
              <i class="fas fa-arrow-left"></i>
              <span>Retour</span>
            </button>
            <button 
              type="submit" 
              class="submit-btn"
              [disabled]="f['lastName'].invalid || f['firstName'].invalid || isSubmitting"
              [class.loading]="isSubmitting">
              <ng-container *ngIf="!isSubmitting">
                <i class="fas fa-user-plus"></i>
                <span>Créer le client</span>
              </ng-container>
              <ng-container *ngIf="isSubmitting">
                <i class="fas fa-spinner spinner"></i>
                <span>Création en cours...</span>
              </ng-container>
            </button>
          </div>
        </form>
      </div>

      <!-- Info Card -->
      <div class="glass-card info-card">
        <div class="info-header">
          <div class="info-icon">
            <i class="fas fa-lightbulb"></i>
          </div>
          <h3>Guide de saisie</h3>
        </div>

        <div class="info-content">
          <div class="info-section">
            <h4>
              <i class="fas fa-user"></i>
              Informations Obligatoires
            </h4>
            <ul class="info-list">
              <li>
                <i class="fas fa-check"></i>
                <span>Nom de famille (minimum 2 caractères)</span>
              </li>
              <li>
                <i class="fas fa-check"></i>
                <span>Prénom (minimum 2 caractères)</span>
              </li>
            </ul>
          </div>

          <div class="info-section">
            <h4>
              <i class="fas fa-address-card"></i>
              Informations Optionnelles
            </h4>
            <ul class="info-list">
              <li>
                <i class="fas fa-info-circle"></i>
                <span>Email pour l'envoi des factures</span>
              </li>
              <li>
                <i class="fas fa-info-circle"></i>
                <span>Téléphone pour le contact direct</span>
              </li>
            </ul>
          </div>

          <div class="info-note">
            <i class="fas fa-info-circle"></i>
            <p>Vous pouvez toujours ajouter ou modifier les informations plus tard</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
